import type { DefaultTheme } from 'styled-components';
import type { KeysBeginningWith } from '../../utils/types';
import type { BoxProps } from '../Core';

export const TableSize = {
  Small: 'Small',
  Default: 'Default',
  Large: 'Large',
} as const;
export type TableSize = (typeof TableSize)[keyof typeof TableSize];

export interface TableProps extends BoxProps {
  zebra?: boolean;
  size?: TableSize;
  bordered?: boolean;
  rowHeight?: string;
  insetPadding?: KeysBeginningWith<DefaultTheme, 'spacing'>;
}

export type ColProps = { background?: string };
